import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 10px;

  label {
    display: flex;
    align-items: flex-start;
    gap: 5px;
  }
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  cursor: pointer;

  a {
    font-size: 14px;
  }
`;

export const UpdateArea = styled.div`
  border: 1px dashed black;
  border-radius: 20px;
  width: 100%;
  height: 200px;

  cursor: pointer;

  display: flex;
  justify-content: center;
  align-items: center;

  :hover {
    border: ${({ disabled }) => (disabled ? "none" : "1px dashed blue")};
  }

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const Files = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  width: 100%;
  padding: 10px;
`;

export const UpdateTexts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;

  span {
    font-size: 13px;
  }

  img,
  video,
  audio {
    max-width: 120px;
    max-height: 120px;
    object-fit: cover;
  }
`;

export const RequiredDot = styled.div`
  margin: 2px 0;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

// Progresso do upload (B06 — D21 da parte 2, 03/09/2026). Com teto de 500 MB,
// um envio pode levar minutos: sem sinal de vida o usuário recarrega a página e
// perde o que já subiu.
//
// ⚠️ CORES LITERAIS, não tokens: este componente serve as DUAS áreas, e os
// temas não compartilham escala de neutros — `admin` tem gray1…gray8 e `common`
// tem cinza50…cinza950; só `white` e `black` existem nos dois. Token ausente
// viraria `undefined`, que o styled-components descarta em silêncio (barra
// invisível). O par abaixo tem contraste suficiente sobre fundo claro e escuro.
export const Progress = styled.div`
  position: relative;

  width: 100%;
  height: 18px;
  margin-top: 8px;

  border-radius: 4px;
  overflow: hidden;

  background-color: rgba(0, 0, 0, 0.3);

  span {
    position: relative;
    z-index: 1;

    display: block;
    line-height: 18px;
    text-align: center;

    font-size: 11px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;

  background-color: rgba(76, 89, 128, 0.9);
  transition: width 0.2s ease;
`;
